import { Component } from '@theme/component';

class MobileToolbarComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#setToolbarHeight();
    this.#bindContactTrigger();
    this.#bindCartTrigger();

    window.addEventListener('resize', this.#handleResize);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('resize', this.#handleResize);
    document.body.style.removeProperty('--mobile-toolbar-height');
    document.body.classList.remove('has-mobile-toolbar');
  }

  #handleResize = () => {
    this.#setToolbarHeight();
  };

  #setToolbarHeight() {
    const height = this.offsetHeight;
    document.body.style.setProperty('--mobile-toolbar-height', `${height}px`);
    document.body.classList.toggle('has-mobile-toolbar', height > 0);
  }

  #bindContactTrigger() {
    for (const trigger of this.querySelectorAll('[data-contact-trigger]')) {
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const panel = document.querySelector('contact-panel-component');
        if (!panel) return;
        panel.toggle();
      });
    }
  }

  #bindCartTrigger() {
    for (const trigger of this.querySelectorAll('[data-cart-trigger]')) {
      trigger.addEventListener('click', () => {
        const drawer = document.querySelector('cart-drawer-component');

        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
          return;
        }

        if (drawer && typeof drawer.showDialog === 'function') {
          drawer.showDialog();
        }
      });
    }
  }

}

customElements.define('mobile-toolbar-component', MobileToolbarComponent);
